import storage from "src/utils/storage/cryptoStorage";
import { axiosInstance } from "../config/axiosInstance";


export const baseService = {
    getAll: async<T>(url: string) => {
        try {
            const token = storage.getLocalStorage("token");

            if (!token) {
                throw new Error("Token not found");
            }
            const response = await axiosInstance.get<T>(url, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });
            return response.data;
        } catch (error: any) {
            console.log("baseService", error);
            throw new Error(error);
        }
    },
    getById: async<T>(url: string, id: number) => {
        try {
            const token = storage.getLocalStorage("token");

            if (!token) {
                throw new Error("Token not found");
            }
            const response = await axiosInstance.get<T>(url + id, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });
            return response.data;
        } catch (error: any) {
            console.log("baseService getById", error);
            throw new Error(error);
        }
    },
    add: async<T>(url: string, data: any) => {
        try {
            const token = storage.getLocalStorage("token");

            if (!token) {
                throw new Error("Token not found");
            }
            const response = await axiosInstance.post<T>(url, data, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            })
            return response.data;
        } catch (error: any) {
            console.log("baseService add", error);
            throw new Error(error);
        }
    },
    update: async<T>(url: string, data: any) => {
        try {
            const token = storage.getLocalStorage("token");

            if (!token) {
                throw new Error("Token not found");
            }
            const response = await axiosInstance.put<T>(url, data, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });
            return response.data;
        } catch (error: any) {
            console.log("baseService update", error);
            throw new Error(error);
        }
    },
    delete: async<T>(url: string, id: number) => {
        try {
            const token = storage.getLocalStorage("token");

            if (!token) {
                throw new Error("Token not found");
            }
            const response = await axiosInstance.delete<T>(url + id, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });
            return response.data;
        } catch (error: any) {
            console.log("baseService delete", error);
            throw new Error(error);
        }
    }
}